// Test Workspace
export const ATLASSIAN_TEST_WORKSPACE_INTERCOM_APP_ID = 'rntvustl';
// Partner Customer Advocate Workspace
export const PARTNER_CUSTOMER_ADVOCATE_INTERCOM_APP_ID = 'vch29cu8';
// PCA Testing Workspace
export const PCA_TESTING_WORKSPACE_INTERCOM_APP_ID = 'c62dcm35';

export enum INTERCOM_EVENTS {
  BOOT = 'ppc_intercom_boot',
  SHUTDOWN = 'ppc_intercom_shutdown',
}
